<template>
  <div class="parts-shop">
    <Navbar
      class="navbar"
      :statusHeight="statusHeight"
      language="ug"
      background="transparent"
      :isNavtiveBack="true"
      :backIcon="require('@/assets/icon_back_white.png')"
    >
      <template #title>
        <span class="nav-title">{{ $t('商城') }}</span>
      </template>
      <template #operation>
        <div class="nav-operation">
          <img
            class="package-icon"
            src="../../assets/images/back-package.png"
            alt=""
            @click="openPackage"
          />
          <img
            class="package-icon"
            src="../../assets/images/icon_wenti.png"
            alt=""
            @click="explain"
          />
        </div>
      </template>
    </Navbar>
    <div class="blance-count">
      <div class="diamond" @click="buyGoldCoin">
        <img src="@/assets/images/gold_coin_icon.webp" alt="" />
        <span class="midden">:</span>
        <span>{{ PageCommonModule.userInfo.goldCoin }}</span>
        <img class="blance-add" src="@/assets/images/blance-add.png" alt="" />
      </div>
      <div class="gameCoin" @click="buyGameCoin">
        <img src="@/assets/part-gameCoin.png" alt="" />
        <span class="midden">:</span>
        <span>{{ PageCommonModule.userInfo.gameCoin }}</span>
        <img class="blance-add" src="@/assets/images/blance-add.png" alt="" />
      </div>
    </div>
    <div class="content">
      <div v-for="(value, index) in shopGroups" :key="value.type" class="group-item">
        <SkinCard :title="value.name" :type="value.type" :groups="shopDataList(index)" @handleShowPart="handleShowPart" />
      </div>
    </div>

    <!-- 兑换弹窗 -->
    <ConvertDialog :isShow.sync="isShow" :partInfo="partInfo" />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { CommonModule } from '@/store/modules/common'
import { PageCommonModule } from '@/store/modules/page_common'
import {
  appFunc_changeBar,
  appFunc_LiveCoinsExchangeBackpack,
  appFunc_LiveCoinsExchangeBuyGold,
} from '@/utils/bridge'
import { imageAdapter } from '@/utils/index'
import SkinCard from './components/SkinCard.vue'
import ConvertDialog from './components/ConvertDialog.vue'

export default {
  components: {
    Navbar,
    SkinCard,
    ConvertDialog
  },
  data() {
    return {
      isShow: false,
      PageCommonModule,
      timeList: [7, 15, 30],
      activeIndexTime: 0,
      language: 'ug',
      statusHeight: 0,
      partInfo: {},
      headUrl: '',
      shopGroups: [
        { type: 1, name: '头像框',  groups: [] },
        { type: 2, name: '聊天气泡',  groups: []},
        { type: 3, name: '资料皮肤卡',  groups: []},
        { type: 4, name: '其他兑换',  groups: [] }
      ]
    }
  },
  methods: {
    // 钻石
    buyGoldCoin() {
      appFunc_LiveCoinsExchangeBuyGold()
    },
    // 游戏币
    buyGameCoin() {
      this.$router.push({
        path: '/gameCoin',
        query: {
          language: this.language,
          statusBarHeight: this.statusHeight,
          isH5: true
        }
      })
    },
    // 适配器
    getImageAdapter(url, container, className) {
      imageAdapter(url, container, className, this.$nextTick)
    },
    // 规则
    explain() {
      this.$router.push(
        `/partsRules?language=${this.language}&statusHeight=${this.statusHeight}`
      )
    },
    // 背包
    openPackage() {
      appFunc_LiveCoinsExchangeBackpack()
    },
    // 打开兑换弹窗
    handleShowPart(value) {
      this.isShow = true
      this.partInfo = value.partInfo
    },
    setLanguage() {
      // 获取当前语言
      console.log('setLanguage', window.location.href)
      const data = this.$route.query.language || 'ug'
      this.language = data
      this.$i18n.locale = data
      CommonModule.setLanguage(data)
      appFunc_changeBar({ statusBarModel: false, navBarBackground: '#171C28' })
    },
    getUserInfo() {
      if(Object.keys(PageCommonModule.userInfo).length > 2) return
      PageCommonModule.getUserInfo()
    },
    getShopDataList() {
      if(PageCommonModule.shopDataList.length) return
      PageCommonModule.getShopDataList()
    }
  },
  computed: {
    shopDataList() {
      return index => {
        return PageCommonModule.shopDataList[index] || []
      }
    }
  },
  async created() {
    this.setLanguage()
    this.statusHeight = +this.$route.query.statusBarHeight
    this.getUserInfo()
    this.getShopDataList()
  }
}
</script>

<style lang="scss" scoped>
.nav-title {
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
}

.nav-operation {
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  img:nth-child(1) {
    margin-right: 8px;
  }
}

.parts-shop {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background-color: #251b5c;
  .navbar {
    position: relative;
    z-index: 10;
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 244px;
    background: url('../../assets/images/shop-container-bg.webp') no-repeat;
    background-size: contain;
    transition: all 0.3s ease-in-out;
  }

  .blance-count {
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    height: 52px;
    .diamond,
    .gameCoin {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      color: #c7c7c7;
      margin: 12px 14px 0 14px;

      img {
        width: 24px;
        height: 24px;
      }

      .midden {
        margin: 0 5px 0 2px;
      }
      .blance-add {
        margin-left: 3px;
        width: 16px;
        height: 16px;
      }
    }
  }

  .content {
    position: relative;
    z-index: 10;
    flex: 1;
    overflow-y: scroll;
    padding: 16px 14px;

    .group-item {
      padding-bottom: 26px;
    }
  }
}

.dialog-part {
  width: 322px;
  // height: 344px;
  background: #1a0d43;

  .dialog-part-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    background: url('../../assets/part-dialog-title-bg.png') no-repeat;
    background-size: contain;
    padding: 30px 0 15px 0;

    .title-img {
      width: 100%;
      height: 80px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }

    .part-pic-pendant {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
    }

    span {
      padding-top: 15px;
    }
  }

  .dialog-part-content {
    padding: 10px 28px 20px;

    .part-price-diamond {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;

      .part-price {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .part-price-origin {
        position: relative;
        font-size: 16px;
        color: #999999;

        &::after {
          content: ' ';
          position: absolute;
          top: 50%;
          left: -2px;
          width: 105%;
          height: 1.8px;
          background: #999999;
        }
      }
    }

    .part-time {
      .part-time-title {
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        padding: 20px 0 10px 0;
      }

      .part-time-list {
        display: flex;
        justify-content: space-between;

        .part-time-item {
          width: 83px;
          height: 46px;
          line-height: 46px;
          text-align: center;
          background: rgba(0, 0, 0, 0.2);
          border-radius: 8px 8px 8px 8px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }

        .part-time-item-active {
          background: rgba(185, 117, 255, 0.2);
          border: 1px solid #b975ff;
        }
      }
    }

    .part-pay {
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: linear-gradient(270deg, #955eff 0%, #b975ff 100%);
      border-radius: 23px;
      font-weight: 400;
      font-size: 16px;
      color: #ffffff;
      margin-top: 22px;
    }
  }
}
::v-deep .van-dialog {
  top: 50%;
}
.package-icon {
  width: 20px !important;
  height: 20px !important;
}
.question-icon {
  font-size: 20px;
}
</style>
